import type { ReactNode } from "react";

import { StyledSelectInput } from "common/form/inputs/select";

import Styles from "./index.module.scss";

type SignerItem = { name: ReactNode; value: string; colorHex: string };
type Props = {
  onChange: (signerIndex: string) => void;
  value: SignerItem["value"];
  items: SignerItem[];
  disabled: boolean;
};

function renderReassignmentItem(item: SignerItem) {
  return (
    <div
      data-automation-id={`signer-dropdown-item-${item.value}`}
      className={Styles.item}
      title={`(${item.value}) ${item.name}`}
    >
      <p className={Styles.color} style={{ background: item.colorHex }} />
      <p className={Styles.name}>{item.name}</p>
    </div>
  );
}

function SignerDropdown({ items, onChange, value, disabled = false }: Props) {
  return (
    <StyledSelectInput
      automationId="signer-dropdown"
      items={items}
      value={value}
      optionRenderer={renderReassignmentItem}
      valueRenderer={renderReassignmentItem}
      onChange={onChange}
      searchable={false}
      clearable={false}
      disabled={disabled}
    />
  );
}

export { SignerDropdown };
